(function () {
  'use strict';

  var FORMSPARK_SELECTOR = 'form[action^="https://submit-form.com"]';
  var startedForms = {};
  var completedFields = {};

  function trackEvent(category, action, name) {
    if (window._paq) {
      window._paq.push(['trackEvent', category, action, name]);
    }
  }

  function fieldKey(field) {
    return field.name || field.id || field.type || 'unknown';
  }

  function isTrackableField(field) {
    if (!field.matches || !field.matches('input, select, textarea')) return false;
    return !field.matches('input[type="hidden"], input[type="submit"], input[type="button"], input[type="reset"]');
  }

  function fieldHasValue(field) {
    if (field.type === 'checkbox' || field.type === 'radio') return field.checked;
    return typeof field.value === 'string' && field.value.trim() !== '';
  }

  function btnLabel(el) {
    var title = el.querySelector ? el.querySelector('.btn-title, .cta-box__btn-line') : null;
    var label = title ? title.textContent : el.textContent;
    label = label.replace(/\s+/g, ' ').trim();
    if (!label) label = el.getAttribute('aria-label') || el.id || 'unnamed';
    return label;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var cta = e.target.closest('.cta-box__btn');
    if (cta) {
      trackEvent('CTA', 'click', btnLabel(cta));
      return;
    }
    var lh = e.target.closest('.lh-cta-btn');
    if (lh) {
      var target = 'browser';
      if (lh.classList.contains('lh-cta-btn--apple')) target = 'apple';
      else if (lh.classList.contains('lh-cta-btn--android')) target = 'android';
      trackEvent('LearningHub', 'app_click', target);
      return;
    }
    var submitBtn = e.target.closest('.form-submit-btn');
    if (submitBtn) {
      trackEvent('Contact', 'submit_click', window.location.pathname);
      return;
    }
    var pageCta = e.target.closest('.btn-cta, a.btn');
    if (pageCta) {
      trackEvent('CTA', 'click', btnLabel(pageCta));
      return;
    }
    var sector = e.target.closest('.sector-btn');
    if (sector) {
      trackEvent('CoursesPage', 'sector_filter', sector.getAttribute('data-sector') || 'unknown');
      return;
    }
    var carousel = e.target.closest('.carousel-btn');
    if (carousel) {
      trackEvent('UI', 'carousel', carousel.classList.contains('carousel-prev') ? 'prev' : 'next');
      return;
    }
    var cookieBtn = e.target.closest('.cookie-btn');
    if (cookieBtn) {
      trackEvent('Consent', 'banner_click', btnLabel(cookieBtn));
      return;
    }
    var generic = e.target.closest('button');
    if (generic) {
      trackEvent('UI', 'button_click', btnLabel(generic));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches(FORMSPARK_SELECTOR)) {
      var interest = form.querySelector('[name="interested_in"]');
      var label = interest && interest.value ? interest.value : window.location.pathname;
      trackEvent('Contact', 'form_submit', label);
    }
  });

  document.addEventListener('focusin', function (e) {
    var field = e.target;
    if (!field.matches || !isTrackableField(field)) return;
    var form = field.closest(FORMSPARK_SELECTOR);
    if (!form) return;
    var formKey = form.id || form.getAttribute('action');
    if (!startedForms[formKey]) {
      startedForms[formKey] = true;
      trackEvent('Contact', 'form_start', window.location.pathname);
    }
  });

  function trackFieldComplete(field) {
    if (!isTrackableField(field) || !fieldHasValue(field)) return;
    var form = field.closest(FORMSPARK_SELECTOR);
    if (!form) return;
    var key = (form.id || form.getAttribute('action')) + ':' + fieldKey(field);
    if (!completedFields[key]) {
      completedFields[key] = true;
      trackEvent('Contact', 'field_complete', fieldKey(field));
    }
  }

  document.addEventListener('change', function (e) {
    var field = e.target;
    if (field.matches && field.matches('select, input[type="checkbox"], input[type="radio"]')) {
      trackFieldComplete(field);
    }
  });

  document.addEventListener('focusout', function (e) {
    var field = e.target;
    if (field.matches && field.matches('input[type="text"], input[type="email"], input[type="tel"], input[type="url"], textarea')) {
      trackFieldComplete(field);
    }
  });

  var fired = {};
  var thresholds = [25, 50, 75, 100];

  function checkScrollDepth() {
    var doc = document.documentElement;
    var total = doc.scrollHeight;
    if (!total) return;
    var visible = ((window.pageYOffset || doc.scrollTop) + window.innerHeight) / total * 100;
    thresholds.forEach(function (t) {
      if (!fired[t] && visible >= t) {
        fired[t] = true;
        trackEvent('ScrollDepth', t + '%', window.location.pathname);
      }
    });
    if (fired[100]) {
      window.removeEventListener('scroll', checkScrollDepth);
    }
  }

  window.addEventListener('scroll', checkScrollDepth, { passive: true });
  checkScrollDepth();
})();
